var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Search.CreateDepartment = function (superClass) {
  extend(CreateDepartment, superClass);
  function CreateDepartment() {
    return CreateDepartment.__super__.constructor.apply(this, arguments);
  }
  CreateDepartment.prototype.template = 'search/templates/create_department';
  CreateDepartment.prototype.events = {
    'shown.bs.modal': '_focusInput',
    'submit': '_handleSubmit'
  };
  CreateDepartment.prototype.render = function () {
    this.$el.html(JST[this.template]());
    this.$modal = this.$('#affiliation-editor-create-department-modal');
    this.$input = this.$('input');
    $('body').append(this.$el);
    return this;
  };
  CreateDepartment.prototype.show = function (value) {
    this.$input.val(value);
    return this.$modal.modal('show');
  };
  CreateDepartment.prototype._handleSubmit = function (e) {
    e.preventDefault();
    this.options.save(this.$input.val());
    this.$modal.modal('hide');
    return false;
  };
  CreateDepartment.prototype._focusInput = function () {
    return this.$input.focus();
  };
  return CreateDepartment;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;